/**
 * 只是一个特简单的存储数据的地方
 * 临时解决方案
 */
const Store = new Map();
const DataCache = {
    get: key => Store.get(key),
    set: (key, value) => Store.set(key, value),
    delete: key => Store.delete(key),
};
export default DataCache;



// WEBPACK FOOTER //
// ./src/api/Store.js